import { Component } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { IBranch, IWorkSlot } from 'src/types/branches';
import Icon from 'src/view/components/Controls/Icon/Icon';
import ModalPopup, { IPopupModalProps } from 'src/view/components/ModalPopup/ModalPopup';
import './style.scss';
interface Props {
  branch: IBranch;
  vertical: IPopupModalProps['vertical'];
}

export default class BranchWorkingTime extends Component<Props, {}> {
  static defaultProps = {
    vertical: 'bottom',
  };

  modal: ModalPopup | null = null;

  renderWorkSlot = (slot: IWorkSlot) => {
    return (
      <div className="d-flex mb-4">
        <div className="d-flex flex-1">
          <span className="text-size-14">{localeStore.t(`txt_${slot.day}`)}</span>
        </div>
        <div className="d-flex flex-column flex-2">
          {slot.start_time ? (
            <span className="text-size-14 family-semibold">
              {slot.start_time} - {slot.close_time}
            </span>
          ) : (
            <span className="text-size-14  color-red  family-semibold">{localeStore.t('txt_closed')}</span>
          )}
          {slot.breaks?.length
            ? slot.breaks.map((breaks) => (
                <span key={breaks.time} className="text-uppercase text-size-12 color-gray2 mt-2">
                  {localeStore.t('break')}: {breaks.start_time}-{breaks.end_time}
                </span>
              ))
            : null}
        </div>
      </div>
    );
  };

  handleEvent = (visible: boolean) => () => {
    if (visible) {
      this.modal?.openModalPopup();
    } else {
      this.modal?.closeModalPopup();
    }
  };

  render() {
    return (
      <ModalPopup
        horizontal="end"
        vertical={this.props.vertical}
        ref={(modal) => (this.modal = modal)}
        content={
          <div className="d-flex animate__faster animate__animated animate__fadeInLeft">
            <div className="branch-working-time d-flex flex-column bg-white">{this.props.branch.work_slots?.map(this.renderWorkSlot)}</div>
          </div>
        }
      >
        <div
          className="d-flex"
          onMouseEnter={this.handleEvent(true)}
          onMouseOver={this.handleEvent(true)}
          onMouseOut={this.handleEvent(false)}
          onMouseLeave={this.handleEvent(false)}
        >
          <Icon name={Icons.Info} size={24} className="color-mainblue" />
        </div>
      </ModalPopup>
    );
  }
}
